/* Oergezond bundel-upgrade (v3.7): badges, prijs per pot, besparing en nette cadeautekst
   bovenop de originele Kaching-bundel. Leest alleen wat Kaching toont, verandert geen prijzen. */
(function () {
  function num(t) { var m = (t || '').replace(/\./g, '').match(/(\d+),(\d{2})/); return m ? parseFloat(m[1] + '.' + m[2]) : null; }
  function eur(n) { return '€' + n.toFixed(2).replace('.', ','); }

  function enhance(blk) {
    var bars = Array.prototype.slice.call(blk.querySelectorAll('.kaching-bundles__bar'));
    var qty = bars.map(function (b) {
      var m = (b.querySelector('.kaching-bundles__bar-title') || {}).textContent;
      m = m && m.trim().match(/^(\d+)\s+Stuk/i);
      return m ? parseInt(m[1], 10) : null;
    });
    var isQty = bars.length >= 2 && qty.every(function (q) { return q; });
    var i1 = qty.indexOf(1);
    var single = i1 >= 0 ? num((bars[i1].querySelector('.kaching-bundles__bar-price') || {}).textContent) : null;
    bars.forEach(function (b, i) {
      // badges alleen bij aantallen (1/2/3 stuks)
      var badge = isQty && bars.length >= 3 ? (i === 1 ? 'Meest gekozen' : (i === bars.length - 1 ? 'Beste deal' : '')) : '';
      if (badge) { if (b.getAttribute('data-lb-badge') !== badge) b.setAttribute('data-lb-badge', badge); }
      else if (b.hasAttribute('data-lb-badge')) b.removeAttribute('data-lb-badge');

      var pricing = b.querySelector('.kaching-bundles__bar-pricing');
      var price = num((b.querySelector('.kaching-bundles__bar-price') || {}).textContent);
      var full = num((b.querySelector('.kaching-bundles__bar-full-price') || {}).textContent);
      var el = pricing && pricing.querySelector('.lb-perpot');
      if (pricing && isQty && qty[i] > 1 && price && single && price / qty[i] < single - 0.005) {
        var t = eur(price / qty[i]) + ' per pot';
        if (!el) { el = document.createElement('span'); el.className = 'lb-perpot'; pricing.appendChild(el); }
        if (el.textContent !== t) el.textContent = t;
      } else if (el) el.remove();
      // besparing in euro's (ook als Kaching een %-ondertitel toont)
      var left = b.querySelector('.kaching-bundles__bar-content-left');
      var sub = b.querySelector('.kaching-bundles__bar-subtitle');
      // besparing altijd in euro's: "Bespaar 19%" van Kaching verbergen, "Je bespaart €x" ervoor in de plaats
      var pct = sub && /bespaar\s*\d+([.,]\d+)?\s*%/i.test(sub.textContent) && !/€/.test(sub.textContent);
      if (pct && price && full && full > price) sub.style.display = 'none';
      if (left && price && full && full > price && (pct || !(sub && sub.textContent.trim()))) {
        var s = 'Je bespaart ' + eur(full - price);
        var sv = left.querySelector('.lb-save');
        if (!sv) {
          sv = document.createElement('span'); sv.className = 'lb-save';
          var vis0 = left.querySelector('.lb-visual');
          if (vis0) left.insertBefore(sv, vis0); else left.appendChild(sv);
        }
        if (sv.textContent !== s) sv.textContent = s;
      }
      // "+ FREE Gift" -> de echte naam van het cadeau
      b.querySelectorAll('.kaching-bundles__free-gift').forEach(function (g) {
        var tx = g.querySelector('.kaching-bundles__free-gift__text');
        if (!tx || !/free gift/i.test(tx.textContent)) return;
        var src = ((g.querySelector('img') || {}).src || '').split('?')[0];
        var same = Array.prototype.filter.call(blk.querySelectorAll('.kaching-bundles__free-gift'), function (o) {
          var t = o.querySelector('.kaching-bundles__free-gift__text');
          return t && !/free gift/i.test(t.textContent) && ((o.querySelector('img') || {}).src || '').split('?')[0] === src;
        })[0];
        tx.textContent = same ? same.querySelector('.kaching-bundles__free-gift__text').textContent.trim() : '+ GRATIS cadeau';
      });
      // v3.11: laat zien wat je krijgt (N potjes + gratis cadeau), zodat het cadeau echt in beeld is
      if (left && isQty && qty[i] > 1 && prodImg) {
        var gi = b.querySelector('.kaching-bundles__free-gift img');
        var gsrc = gi ? sized(gi.currentSrc || gi.src, 200) : '';
        var key = qty[i] + '|' + gsrc;
        var vis = left.querySelector('.lb-visual');
        if (!vis || vis.getAttribute('data-k') !== key) {
          if (!vis) { vis = document.createElement('span'); vis.className = 'lb-visual'; left.appendChild(vis); }
          vis.setAttribute('data-k', key);
          var h = '';
          for (var n = 0; n < qty[i]; n++) h += '<span class="lb-v-item"><img src="' + prodImg + '" alt="" loading="lazy"></span>';
          if (gsrc) h += '<span class="lb-v-plus">+</span><span class="lb-v-item lb-v-gift"><img src="' + gsrc + '" alt="Gratis cadeau" loading="lazy"><em>Gratis</em></span>';
          vis.innerHTML = h;
        }
      }
    });
  }

  function sized(u, w) { if (!u) return ''; u = u.split('?')[0]; return u + '?width=' + w; }
  var prodImg = '';
  (function () {
    var m = location.pathname.match(/\/products\/([^\/?#]+)/);
    if (!m) return;
    fetch('/products/' + m[1] + '.js').then(function (r) { return r.json(); }).then(function (p) {
      var f = p.featured_image || (p.images || [])[0];
      if (f) { prodImg = sized(f.indexOf('//') === 0 ? 'https:' + f : f, 200); schedule(); }
    }).catch(function () {});
  })();

  var q = false;
  function run() { q = false; document.querySelectorAll('section[id^="MainProduct-"] .kaching-bundles__block').forEach(enhance); }
  function schedule() { if (!q) { q = true; requestAnimationFrame(run); } }
  function start() {
    run();
    var host = document.querySelector('section[id^="MainProduct-"] kaching-bundle, section[id^="MainProduct-"] .kaching-bundles__block');
    var target = host ? (host.closest('kaching-bundle') || host.parentNode) : document.body;
    new MutationObserver(schedule).observe(target, { childList: true, subtree: true, characterData: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();

/* Abonnement-teksten van Kaching ("Abonneer & bespaar 20% extra", "20% korting op alle producten") altijd in euro's,
   uitgerekend op de gekozen bundel. Besparingen tonen we nooit in procenten. */
(function () {
  var ORIG = new WeakMap(), LAST = new WeakMap();
  function cents(t) {
    var m = String(t || '').replace(/\s/g, '').match(/(\d+(?:[.,]\d{3})*)(?:[.,](\d{2}))?/);
    return m ? parseInt(m[1].replace(/[.,]/g, ''), 10) * 100 + (m[2] ? parseInt(m[2], 10) : 0) : null;
  }
  function eur(c) { return '€' + (c / 100).toFixed(2).replace('.', ','); }
  var PCT = /(\d+(?:[.,]\d+)?)\s*%/;
  function run() {
    var root = document.querySelector('.kaching-bundles');
    var bar = document.querySelector('.kaching-bundles__bar--selected .kaching-bundles__bar-price');
    if (!root || !bar) return;
    var base = cents(bar.textContent);
    if (!base) return;
    var w = document.createTreeWalker(root, NodeFilter.SHOW_TEXT), t;
    while ((t = w.nextNode())) {
      if (t.parentElement && t.parentElement.closest('.kaching-bundles__bar-subtitle')) continue;
      var cur = t.nodeValue;
      if (LAST.get(t) !== cur) ORIG.set(t, cur);
      var o = ORIG.get(t);
      if (!o || !PCT.test(o) || !/bespaar|korting/i.test(o)) continue;
      var pct = parseFloat(o.match(PCT)[1].replace(',', '.'));
      var amt = eur(Math.round(base * pct / 100));
      var n = /korting op alle producten/i.test(o) ? amt + ' korting per levering' : o.replace(PCT, amt);
      if (cur !== n) { t.nodeValue = n; }
      LAST.set(t, n);
    }
  }
  var q = false;
  function schedule() { if (!q) { q = true; setTimeout(function () { q = false; run(); }, 150); } }
  function start() {
    run();
    new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['class'] });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
